import { render, staticRenderFns } from "./TERCPicker.vue?vue&type=template&id=a773f05c&"
import script from "./TERCPicker.vue?vue&type=script&lang=js&"
export * from "./TERCPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports